import { Metric, onCLS, onFCP, onINP, onLCP, onTTFB } from "web-vitals";

/**
 * Reports Core Web Vitals metrics.
 * Sends to Google Analytics if available, and logs in development.
 */
const sendToAnalytics = (metric: Metric) => {
  const { name, value, rating } = metric;

  console.log(`[Web Vitals] ${name}: ${value.toFixed(1)} (${rating})`);
};

export const reportWebVitals = async () => {
  if (window.location.hostname === "staging.dropshiptool.io") {
    try {
      onLCP(sendToAnalytics);
      onINP(sendToAnalytics);
      onCLS(sendToAnalytics);
      onFCP(sendToAnalytics);
      onTTFB(sendToAnalytics);
    } catch {
      // web-vitals not available — skip silently
    }
  }
};
